import { StatusInfo } from '../common/Status'
import { PaymentStatus } from './types'

export function getPaymentStatusInfo(status: PaymentStatus): StatusInfo {
    const map: Record<PaymentStatus, StatusInfo> = {
        PENDING: { text: 'Pago pendiente', class: 'warning', actionText: '' },
        PREAUTHORIZED: { text: 'Pago preautorizado', class: 'info', actionText: 'Preautorizar pago' },
        APPROVED: { text: 'Pago aprobado', class: 'success', actionText: 'Aprobar pago' },
        PAID: { text: 'Pago realizado', class: 'success', actionText: 'Pago realizado' },
        REJECTED: { text: 'Pago rechazado', class: 'danger', actionText: 'Rechazar pago' },
        REFUND_IN_PROCESS: { text: 'Pago en proceso de reembolso', class: 'warning', actionText: 'Reembolsar pago' },
        PARTIAL_REFUND: { text: 'Pago parcialmente reembolsado', class: 'warning', actionText: 'Reembolsar pago' },
        REFUNDED: { text: 'Pago reembolsado', class: 'success', actionText: 'Reembolsado' },
        ERROR: { text: 'Error en pago', class: 'danger', actionText: 'Error en pago' },
    }

    return map[status] ?? { text: String(status), class: 'secondary' }
}
